
import React from 'react';
import { DatePicker, DayOfWeek } from 'office-ui-fabric-react/lib/DatePicker';
import moment from 'moment';
import get from 'lodash/get';

const ParameterDatePicker = ({
    id,
    onChangeValue,
    options,
    title,
    value
}) => {

    const DATE_FORMAT = 'YYYY-MM-DD';

    const DayPickerStrings = {
        months: [
            'Leden',
            'Únor',
            'Březen',
            'Duben',
            'Květen',
            'Červen',
            'Červenec',
            'Srpen',
            'Září',
            'Říjen',
            'Listopad',
            'Prosinec',
          ],

          shortMonths: ['Led', 'Úno', 'Bře', 'Dub', 'Kvě', 'Čer', 'Črv', 'Srp', 'Zář', 'Říj', 'Lis', 'Pro'],

          days: ['Neděle', 'Pondělí', 'Úterý', 'Středa', 'Čtvrtek', 'Pátek', 'Sobota'],

          shortDays: ['Ne', 'Po', 'Út', 'St', 'Čt', 'Pá', 'So'],

          goToToday: 'Jdi na dnes',
          prevMonthAriaLabel: 'Jdi na předchozí měsíc',
          nextMonthAriaLabel: 'Jdi na následující měsíc',
          prevYearAriaLabel: 'Jdi na předchozí rok',
          nextYearAriaLabel: 'Jdi na následující rok',
          closeButtonAriaLabel: 'Zavřít',
          monthPickerHeaderAriaLabel: '{0}, vyber ke změně roku',
          yearPickerHeaderAriaLabel: '{0}, vyber ke změně měsíce',
    };

    const formatDate = (date) => {
        return moment(date).format('D.M.YYYY');
    }

    const getValue = () => {
        return value
            ? moment(value, DATE_FORMAT).toDate()
            : null;
    }

    const handleSelectDate = (date) => {
        if (onChangeValue) {
            onChangeValue(id, moment(date).format(DATE_FORMAT));
        }
    }
    return (
        <DatePicker
            firstDayOfWeek={DayOfWeek.Monday}
            formatDate={formatDate}
            label={title}
            onSelectDate={handleSelectDate}
            placeholder="Vyberte datum..."
            strings={DayPickerStrings}
            textField={{
                styles: get(options, 'TextBox.styles')
            }}
            value={getValue()}
        />
    );
}

export default ParameterDatePicker;
